import React from 'react';
import { useTranslation } from 'react-i18next';

import { BackButtonRenderProps } from './interfaces';
import { Container, Icon, Text } from './styles';

const BackButton: React.FC<BackButtonRenderProps> = ({ callback, style }) => {
  const { t } = useTranslation();
  return (
    <Container style={style} onClick={() => callback()}>
      <Icon />
      <Text>{t('common.goback')}</Text>
    </Container>
  );
};

export default BackButton;
